import { AdsChunkSize } from './AdsWithInfiniteScroll.types';
import { GetAdsResponse } from '@/api/types/ads.types';
import { padAdsToChunkSize } from '@/utils/helpers';

export const normalizeAdsChunk = (
  data: GetAdsResponse | undefined,
  chunkSize: AdsChunkSize,
  updateQuery: (
    updateFn: (previousQueryResult: GetAdsResponse) => GetAdsResponse
  ) => void
) => {
  if (data?.ads?.nodes && data.ads.nodes.length < chunkSize) {
    updateQuery(() => ({
      ...data,
      ads: {
        ...data.ads,
        nodes: padAdsToChunkSize(data.ads.nodes, chunkSize),
      },
    }));
  }
};
